import React from 'react';
import { FileText } from 'lucide-react';
import { ApplicationFormData, ApplicationFormErrors } from '@/types/application';

interface AdditionalInfoStepProps {
  formData: ApplicationFormData;
  errors: ApplicationFormErrors;
  updateFormData: (updates: Partial<ApplicationFormData>) => void;
  setErrors: (errors: ApplicationFormErrors) => void;
}

export const AdditionalInfoStep: React.FC<AdditionalInfoStepProps> = ({
  formData,
  errors,
  updateFormData,
  setErrors,
}) => {
  const handleChange = (field: keyof ApplicationFormData, value: any) => {
    updateFormData({ [field]: value });
    if (errors[field]) {
      setErrors({ ...errors, [field]: undefined });
    }
  };

  const wordCount = formData.whyDoYouWantToDoProgramme?.split(/\s+/).filter(word => word.length > 0).length || 0;

  return (
    <div>
      <h5 className="fw-bold mb-3">Additional Information</h5>
      
      <div className="row">
        <div className="col-12 mb-3">
          <label className="form-label fw-semibold">
            Why do you want to do the programme? <span className="text-danger">*</span>{' '}
            <span className="text-muted">(approximately 150 words)</span>
          </label>
          <div className="input-group">
            <span className="input-group-text bg-light">
              <FileText size={18} className="text-muted" />
            </span>
            <textarea
              className={`form-control ${errors.whyDoYouWantToDoProgramme ? 'is-invalid' : ''}`}
              rows={6}
              value={formData.whyDoYouWantToDoProgramme || ''}
              onChange={(e) => handleChange('whyDoYouWantToDoProgramme', e.target.value)}
              placeholder="Explain why you want to do this programme (approximately 150 words)"
              maxLength={1000}
            />
          </div>
          {errors.whyDoYouWantToDoProgramme && (
            <div className="invalid-feedback d-block">
              {errors.whyDoYouWantToDoProgramme}
            </div>
          )}
          <div className="d-flex justify-content-between mt-1">
            <small className="text-muted">
              Word count: {wordCount} / ~150 words
            </small>
            <small className="text-muted">
              Character count: {(formData.whyDoYouWantToDoProgramme || '').length} / 1000
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

